import { AfterViewInit, Component } from '@angular/core';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { Configuration } from '../../../core/configuration/configuration';
import { EPaymentType } from '../../../core/Enums/EPaymentType.enum';
import { A3LEmployeeAdvance } from '../../../core/models/a3LEmployeeAdvance.model';
import { A3LEmployeeExtraPay } from '../../../core/models/a3LEmployeeExtraPayment.model';
import { A3LEmployeeVariableConcept } from '../../../core/models/a3LEmployeeVariableConcept.model';
import { BolsaVacaciones } from '../../../core/models/bolsaVacaciones.model';
import { PageList } from '../../../core/models/pageList.model';
import { SolicitudBolsaVacaciones } from '../../../core/models/SolicitudBolsaVacaciones.model';
import { A3LEmployeeService } from '../../../core/services/a3LEmployee.service';
import { BolsaVacacionesService } from '../../../core/services/bolsaVacaciones.service';
import { SolicitudBolsaVacacionesService } from '../../../core/services/solicitudesBolsaVacaciones.service';
import { A3LEmployeeHiringDates } from '../../../core/models/a3LEmployeeHiringDates.model';
import { Utilidades } from '../../../core/helper/utilidades';

@Component({
  selector: 'app-BolsaVacacionesDetail',
  templateUrl: './BolsaVacacionesDetail.component.html',
  styleUrls: ['./BolsaVacacionesDetail.component.css'],
  providers: [BolsaVacacionesService, SolicitudBolsaVacacionesService, A3LEmployeeService]
})
export class BolsaVacacionesDetailComponent implements AfterViewInit {

  panelIcon = 'wallet'; // material icon
  panelTitle = 'Bolsa de vacaciones';
  panelDescription = '';

  //calculoBolsaVacaciones: CalculoBolsaVacacionesModel;
  bolsaVacaciones: BolsaVacaciones;
  solicitudes: SolicitudBolsaVacaciones[] = new Array<SolicitudBolsaVacaciones>();
  conceptosCreados = new PageList<A3LEmployeeVariableConcept>();
  solicitud: SolicitudBolsaVacaciones = new SolicitudBolsaVacaciones();
  anticipos: A3LEmployeeAdvance[] = new Array<A3LEmployeeAdvance>();
  pagasExtras: A3LEmployeeExtraPay[] = new Array<A3LEmployeeExtraPay>();

  selectedCompany: number;
  selectedYear: number;
  selectedEmployee: string;

  importeBolsaDevengado: number;

  showSearchPanel: boolean = false;

  loading: boolean = false;
  id: string;

  tipoDestino = [
    { value: 0, text: 'Concepto' },
    { value: 1, text: 'Anticipo' },
  ];

  // employeeCode: string;
  // companyCode: string;
  // attributionCode: string;
  // year: number;

  constructor(
    protected _bolsaVacacionesService: BolsaVacacionesService,
    protected _solicitudesBolsaVacacionesService: SolicitudBolsaVacacionesService,
    protected _employeeService: A3LEmployeeService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    protected _location: Location
  ) {
    this.conceptosCreados.pageData = new Array<A3LEmployeeVariableConcept>();
    this.solicitudes = new Array<SolicitudBolsaVacaciones>();
  }

  obtenerBolsaVacaciones() {
    this.loading = true;
    this._route.params.subscribe(params => {

      this.id = params['id'] as string;

      if (this.id) {
        this._bolsaVacacionesService.getModel(this.id).subscribe(res => {
          this.bolsaVacaciones = res;
          this.obtenerAnticipos();
          this.obtenerSolicitudesBolsa();
          this.obtenerConceptosVariablesCreados();
          this.obtenerPagasExtras();
          this.calcularImporteBolsaDevengado();
          this.loading = false;
        },
          err => {
            this.loading = false;
            this._messageDialog.ShowException(err);
          });
      }
    });
  }

  calcularImporteBolsaDevengado() {

    const fechaActual = new Date();

    this._employeeService.getHiringDates(this.bolsaVacaciones.CodigoEmpresa, this.bolsaVacaciones.CodigoTrabajador).subscribe((res: A3LEmployeeHiringDates) => {

      let labourPeriodStartDate: Date = new Date(res.labourPeriodStartDate);
      let workingDays = 0;
      let noWorkingDays = 0;
      let differenceInDaysAllWorkingYear = 1;

      let daysOnYear = 365;

      if(Utilidades.leapYear(fechaActual.getFullYear())){
        daysOnYear++;
      }

      if (res != null) {
        if ((labourPeriodStartDate.getMonth() + 1) > 1 && labourPeriodStartDate.getFullYear() === fechaActual.getFullYear()) {
          noWorkingDays = this.getDifferenceInDays(labourPeriodStartDate, new Date(fechaActual.getFullYear(), 0, 1));
          differenceInDaysAllWorkingYear = daysOnYear - noWorkingDays;

        } else {
          labourPeriodStartDate = new Date(fechaActual.getFullYear(), 1, 1);
          differenceInDaysAllWorkingYear = daysOnYear;
        }

        workingDays = this.getDifferenceInDays(labourPeriodStartDate, fechaActual);
      }

      this.importeBolsaDevengado = Math.abs((this.bolsaVacaciones.ImporteProporcional / differenceInDaysAllWorkingYear) * (workingDays))

    },
      error => {
        console.error(error);
        this.importeBolsaDevengado = 0;
      }
    );
  }

  getDifferenceInDays(startDate: Date, endDate: Date) {
    let differenceInTime =
      startDate.getTime() - endDate.getTime();

    return Math.round
      (differenceInTime / (1000 * 3600 * 24));
  }

  obtenerConceptosVariablesCreados() {
    this._employeeService.getEmployeeVariableConcepts(this.bolsaVacaciones.CodigoEmpresa, this.bolsaVacaciones.CodigoTrabajador, this.bolsaVacaciones.Ejercicio).subscribe(
      res => {
        if (res) {
          this.conceptosCreados = res;
          if (!res.pageData) {
            this.conceptosCreados.pageData = new Array<A3LEmployeeVariableConcept>();
          }
        }
      },
      error => {
        console.error(error);
      }
    )
  }

  obtenerAnticipos() {
    this._bolsaVacacionesService.getAdvances(this.bolsaVacaciones.CodigoEmpresa, this.bolsaVacaciones.CodigoTrabajador, this.bolsaVacaciones.Ejercicio).subscribe(
      (res: A3LEmployeeAdvance[]) => {
        if (res) {
          this.anticipos = res;
        }
      },
      error => {
        console.error(error);
      }
    )
  }

  obtenerPagasExtras() {
    this._employeeService.getExtraPayments(this.bolsaVacaciones.CodigoEmpresa, this.bolsaVacaciones.CodigoTrabajador).subscribe(
      (res: A3LEmployeeExtraPay[]) => {
        if (res) {
          this.pagasExtras = res;
        }
      },
      error => {
        console.error(error);
      }
    )
  }

  obtenerSolicitudesBolsa() {
    let params: HttpParams = new HttpParams();
    params = params.set("year", this.bolsaVacaciones.Ejercicio.toString());
    params = params.set("companyCode", this.bolsaVacaciones.CodigoEmpresa.toString());

    this._solicitudesBolsaVacacionesService.getAll(this.bolsaVacaciones.CodigoTrabajador, params).subscribe((res: SolicitudBolsaVacaciones[]) => {
      this.solicitudes = res;
    },
      error => {
        console.error(error);
      })
  }

  goBack() {
    this._location.back();
  }

  ngAfterViewInit(): void {
    this.showSearchPanel = this._route.snapshot.routeConfig.path === Configuration.newPath;
    if (!this.showSearchPanel) {
      setTimeout(() => this.obtenerBolsaVacaciones());
    }
  }

  onButtonSolicitarClick() {

    if (this.solicitud.Importe > this.bolsaVacaciones.Importe) {
      this._messageDialog.ShowAlert("El importe solicitado no puede ser superior al disponible", "Cantidad incorrecta");
      return;
    }

    this.solicitud.CodigoTrabajador = this.bolsaVacaciones.CodigoTrabajador;
    this.solicitud.CodigoEmpresa = this.bolsaVacaciones.CodigoEmpresa;
    this.solicitud.Ejercicio = this.bolsaVacaciones.Ejercicio;
    this.solicitud.A3LVariableConceptId = '';

    if (!this.solicitud.A3LExtraPaymentId)
      this.solicitud.A3LExtraPaymentId = '';


    this._solicitudesBolsaVacacionesService.add<SolicitudBolsaVacaciones>(this.solicitud, this.bolsaVacaciones.CodigoTrabajador).subscribe(res => {
      this._messageDialog.ShowMessage("Solicitud registrada correctamente", "Nueva solicitud");
      this.obtenerBolsaVacaciones();
    },
      error => {
        this._messageDialog.ShowException(error);
      });
  }

  onButtonBuscarClick() {
    this.loading = true;
    this._bolsaVacacionesService.getAllByCompanyEmployeeAndYear(this.selectedCompany, this.selectedEmployee, this.selectedYear).subscribe(res => {
      if (res) {
        this.bolsaVacaciones = res;
        this.obtenerSolicitudesBolsa();
      }
      this.loading = false;
    },
      err => {
        this._messageDialog.ShowException(err);
        this.loading = false;
      });
  }

  disableButtonSolicitar(ngForm: NgForm): boolean {
    return this.bolsaVacaciones && this.bolsaVacaciones.Importe == 0 || !ngForm.form.valid;
  }

  isAdvanceSelected(): boolean {
    return this.solicitud && this.solicitud.Destino == EPaymentType.Advance;
  }

  getFirstExtraPayment(data): string {
    if (data.extraPaymentSources != null && data.extraPaymentSources.length > 0)
      return data.extraPaymentSources[0].description;
    else
      return ''
  }
}
